import mixpanel from 'mixpanel-browser';

// Initialize Mixpanel
mixpanel.init('4e9b4e0dce7f978fd4ab9b1041b3aa19', {
  debug: process.env.NODE_ENV === 'development',
  track_pageview: true,
  persistence: 'localStorage',
  ignore_dnt: true
});

// Identify a user (creator)
export const identifyCreator = (creatorId: string, creatorName: string) => {
  mixpanel.identify(creatorId);
  mixpanel.people.set({
    $name: creatorName,
    creator_id: creatorId
  });
};

// Track button clicks
export const trackButtonClick = (buttonName: string, properties?: Record<string, any>) => {
  mixpanel.track('Button Click', {
    button_name: buttonName,
    ...properties
  });
};

export default mixpanel; 